
<div class="modal" #exitModal tabindex="-1" role="dialog" [id]="modalId" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" >
      <div class="modal-content">
        <div class="modal-body">
          <h1 class="header1" style="margin-bottom: 10px;">{{title}}</h1>
          <p [innerHTML]="text"></p>
        </div>
        <div *ngIf="type === 'danger'" class="modal-footer d-flex justify-content-between">
          <button  class="btn btn-auto" style="max-width: 43%; min-width: 35%;" data-dismiss="modal">{{firstBtn}}</button>
          <button  class="btn redBtn btn-auto" style="max-width: 53%; min-width: 35%;" (click)="emitAction1()">{{secondBtn}}</button>
        </div>
        <div *ngIf="type === 'info'" class="modal-footer d-flex">
          <button class="btn purpleBtn btn-auto mr-auto" data-dismiss="modal">{{firstBtn}}</button>
        </div>
        <div *ngIf="type === 'confirm'" class="modal-footer d-flex justify-content-between">
          <button  class="btn btn-auto purpleBtn" style="max-width: 53%; min-width: 35%;" (click)="emitAction1()">{{firstBtn}}</button>
          <button class="btn btn-auto" style="max-width: 43%; min-width: 35%;" data-dismiss="modal">{{secondBtn}}</button>
        </div>
      </div>
    </div>
  </div>